import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IPTVEditorComponent } from './iptv_editor.component';

import { FilterGroupPipe } from './iptv_filterGroup.pipe';
import { FilterChannelsPipe } from './iptv_filterChannels.pipe';
import { AutofocusDirective } from "./autofocus.directive";

import { SpatialNavigationService } from "./spatial-navigation.service";

@NgModule({
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule
  ],
  exports: [ IPTVEditorComponent ],
  declarations: [ IPTVEditorComponent, FilterGroupPipe, FilterChannelsPipe, AutofocusDirective ],
  providers: [SpatialNavigationService]
})
/**
 * Модуль для редактирования плейлиста.
 * @example 
 * <iptv-editor [channels]="channels" [groups]="groups" [groupSelected]="groupSelected" (selectedGroup)="selected_group($event)
 * [server]="server" [token]="token"
 * (changeChannel)="change_channel($event)" (removeChannel)="remove_channel($event)" (playChannel)="play_channel($event)" 
 * (changeGroup)="change_group($event)"  (epgDayChannel)="epg_day_channel($event)" 
 * (emptyTrashEvent)="empty_trash_event()" 
 * (groupRemoveEvent)="remove_group($event)"
 * (epgChannels)="epg_channels_get($event)
 * >
 * </iptv-editor>
 */
export class IPTVEditorModule { }